/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
  .main-container {
    padding-left: calc(${$.sidebarContentWidth} + 1rem);
  }

  /* Opted into by ExternalLayout's padded prop. That layout has no sidebar, so the gutter above is
     dead space and — being the only padding .main-container sets — leaves a large left indent against
     a flush top and right. Compound selector so it beats both the rule above and the mobile override,
     whatever order they land in. */
  .main-container.main-container-external {
    padding: 0rem !important;
  }
`;
